// Static content + high-resolution imagery for The Pisces Group LLC site.
// No backend — this is a frontend-only replica with mocked/static data.

export const brand = {
  name: "Pisces Group LLC.",
  tagline: "Sourcing Excellence · Delivering Elegance",
  year: 2026,
};

export const navLinks = [
  { id: "home", label: "Home" },
  { id: "about", label: "About Us" },
  { id: "expertise", label: "Our Expertise" },
  { id: "why", label: "Why Choose Us" },
  { id: "contact", label: "Contact Us" },
];

export const images = {
  hero:
    "https://images.unsplash.com/photo-1722421492323-eaf9c401befe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBjb25zdHJ1Y3Rpb24lMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzg4NDYwMjQ4fDA&ixlib=rb-4.1.0&q=85",
  aboutConstruction:
    "https://images.unsplash.com/photo-1763189158851-a12144e779b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxidWlsZGluZyUyMHByb2plY3QlMjBzaXRlfGVufDB8fHx8MTc4ODQ2MDI0OHww&ixlib=rb-4.1.0&q=85",
  aboutKitchen:
    "https://images.unsplash.com/photo-1639405069836-f82aa6dcb900?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBtb2Rlcm4lMjBraXRjaGVufGVufDB8fHx8MTc4ODQ2MDI0OHww&ixlib=rb-4.1.0&q=85",
  dividerFacade:
    "https://images.unsplash.com/photo-1483366774565-c783b9f70e2c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxhcmNoaXRlY3R1cmFsJTIwZmFjYWRlfGVufDB8fHx8MTc4ODQ2MDMzOXww&ixlib=rb-4.1.0&q=85",
  dividerBlueprint:
    "https://images.unsplash.com/photo-1762146828422-50a8bd416d3c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHxibHVlcHJpbnQlMjBjb25zdHJ1Y3Rpb258ZW58MHx8fHwxNzg4NDYwMzM5fDA&ixlib=rb-4.1.0&q=85",
};

export const heroEyebrow = [
  "Building Supplies",
  "Home Furnishings",
  "Shipping & Logistics",
  "Construction & Engineering Management",
  "Heavy Equipment & Earthwork",
  "Asphalt",
  "Concrete Block Manufacturing",
];

export const heroLede =
  "Your trusted partner in securing the finest materials, furnishings, and logistics — wherever your project takes you.";

export const aboutText =
  "At Pisces Group LLC., we specialize in curating and delivering premium solutions for your projects and lifestyle needs. With a reputation built on trust, quality, and global reach, we serve as your partner in securing the finest building materials, home furnishings, and shipping services.";

export const expertise = [
  {
    num: "01",
    title: "Building Supplies & Procurement",
    text:
      "We source and provide high-quality building materials tailored to your specifications. From foundation to finishing details, we ensure durability, efficiency, and sophistication in every product.",
    img:
      "https://customer-assets-jt897jd0.emergentagent.net/job_responsive-clone-20/artifacts/vs8u4hrf_image.png",
    alt: "Building supplies procurement and warehouse logistics",
  },
  {
    num: "02",
    title: "Home Furnishings",
    text:
      "Elevate your spaces with carefully selected furnishings that combine timeless design with modern comfort.",
    img:
      "https://images.unsplash.com/photo-1598928506311-c55ded91a20c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc4ODQ2MDMzOXww&ixlib=rb-4.1.0&q=85",
    alt: "Elegant home furnishings curated by Pisces Group LLC",
  },
  {
    num: "03",
    title: "Shipping & Logistics",
    text:
      "Our reliable logistics network ensures your goods are delivered with care, efficiency, and precision.",
    img:
      "https://customer-assets-jt897jd0.emergentagent.net/job_responsive-clone-20/artifacts/ee9sx9sp_image.png",
    alt: "Shipping and logistics services by Pisces Group LLC",
  },
  {
    num: "04",
    title: "Construction & Engineering Management",
    text:
      "We oversee complex builds from groundbreaking to final walkthrough, coordinating engineers, contractors, and timelines to keep every project on schedule and on spec.",
    img:
      "https://customer-assets-jt897jd0.emergentagent.net/job_responsive-clone-20/artifacts/1lphshig_image.png",
    alt: "Construction and engineering management by Pisces Group LLC",
  },
  {
    num: "05",
    title: "Heavy Equipment & Earthwork",
    text:
      "From site grading to excavation, our heavy equipment fleet and skilled operators prepare the ground for projects of any scale, safely and on time.",
    img:
      "https://customer-assets-jt897jd0.emergentagent.net/job_responsive-clone-20/artifacts/dc84qv0v_image.png",
    alt: "Heavy equipment and earthwork services by Pisces Group LLC",
  },
  {
    num: "06",
    title: "Asphalt",
    text:
      "We deliver durable asphalt solutions for roadways, parking areas, and foundations, built to withstand demanding environments and heavy use.",
    img:
      "https://customer-assets-jt897jd0.emergentagent.net/job_responsive-clone-20/artifacts/blwqyu58_image.png",
    alt: "Asphalt paving services by Pisces Group LLC",
  },
  {
    num: "07",
    title: "Concrete Block Manufacturing",
    text:
      "We manufacture high-quality concrete blocks built for strength and consistency, supplying reliable material for foundations, walls, and structural projects.",
    img:
      "https://customer-assets-jt897jd0.emergentagent.net/job_responsive-clone-20/artifacts/mbn1jlpg_image.png",
    alt: "Concrete block manufacturing by Pisces Group LLC",
  },
];

export const whyCards = [
  {
    title: "Competitive Pricing",
    text:
      "Premium sourcing at rates that respect your budget, without ever compromising on quality.",
    icon: "pricing",
  },
  {
    title: "Experienced Team",
    text:
      "A dedicated team with deep expertise across procurement, furnishing, and global logistics.",
    icon: "team",
  },
  {
    title: "Quality Assured",
    text:
      "Every material and finish is vetted for durability, craftsmanship, and lasting sophistication.",
    icon: "quality",
  },
  {
    title: "Customer First",
    text:
      "Your goals guide every decision — responsive, transparent, and partnered until the last delivery.",
    icon: "customer",
  },
];

export const contact = {
  address: ["2890 W Broward Blvd Unit B-688", "Fort Lauderdale, FL 33312"],
  phones: [
    { label: "(242) 436-1951", href: "tel:+12424361951" },
    { label: "(787) 688-8887", href: "tel:+17876888887" },
  ],
  email: "thepiscesgroupbahamas@gmail.com",
  facebook: "https://www.facebook.com/share/1BqZGtVyTs/",
  intro: "Let's source it, furnish it, and deliver it — with excellence.",
};

export const developer = {
  label: "Let's Print",
  href: "https://letsprint.ai/contact?service=website-development",
};
